import Udesk from 'Udesk';
import React, { FC, memo, useMemo } from 'react';
import { Select } from 'udesk-ui';
import { SelectProps } from 'udesk-ui/lib/select';
import UdeskLocales from 'UdeskLocales';

interface TemplateProps extends SelectProps<number> {
    range?: number;
}

const Template: FC<TemplateProps> = memo((props) => {
    const { range, ...restProps } = props;

    const options = useMemo(() => {
        if (range === Udesk.enums.assessFrequencyTypes.everyDay.id) {
            return [
                {
                    label: /* 今天 */ UdeskLocales['current'].pages.intelligentAnalysis
                        .intelligentTags.components.timeRange.index.today,
                    value: 'today',
                },
                {
                    label: /* 昨天 */ UdeskLocales['current'].pages.intelligentAnalysis
                        .intelligentTags.components.timeRange.index.yesterday,
                    value: 'yesterday',
                },
                {
                    label: /* 前天 */ UdeskLocales['current'].pages.intelligentAnalysis
                        .intelligentTags.components.timeRange.index.theDayBeforeYesterday,
                    value: 'the_day_before_yesterday',
                },
            ];
        } else if (range === Udesk.enums.assessFrequencyTypes.everyWeek.id) {
            return [
                {
                    label: /* 本周 */ UdeskLocales['current'].pages.intelligentAnalysis
                        .intelligentTags.components.timeRange.index.thisWeek,
                    value: 'this_week',
                },
                {
                    label: /* 上周 */ UdeskLocales['current'].pages.intelligentAnalysis
                        .intelligentTags.components.timeRange.index.lastWeek,
                    value: 'last_week',
                },
            ];
        } else if (range === Udesk.enums.assessFrequencyTypes.everyMonth.id) {
            return [
                {
                    label: /* 本月 */ UdeskLocales['current'].pages.intelligentAnalysis
                        .intelligentTags.components.timeRange.index.thisMonth,
                    value: 'this_month',
                },
                {
                    label: /* 上月 */ UdeskLocales['current'].pages.intelligentAnalysis
                        .intelligentTags.components.timeRange.index.lastMonth,
                    value: 'last_month',
                },
            ];
        } else {
            return [];
        }
    }, [range]);

    return <Select options={options} {...restProps} />;
});

export default Template;
